

import React, { Suspense, useCallback, useEffect } from 'react';
import { componentViews } from 'app/shared/config/mapper';
import { returnComponent } from './methode-component-utils';
import { v4 as uuidv4 } from 'uuid';

interface IConfComponent {
  code: string;
  listCode: any;
  props?: any;
  key?: any;
}

const Index: React.FC<IConfComponent> = ({ code, listCode, props, key }) => {
  const filterDataList = (componentDataList: any, componentDataKey: string) => {
    return componentDataList?.find(e => e.componentDataKey === componentDataKey);
  };

  if ((!listCode?.find(e => e.componentDataKey === code)) && (!listCode?.find(e => e?.actionDataKey === code))) return null;




  const componentView = componentViews.get(code);


  return (
    <Suspense fallback={<></>}>
      {returnComponent(componentView.module, componentView.component, {
        ...props,
        dataConf: filterDataList(listCode, code),
      })}
    </Suspense>
  );
};

export default React.memo(Index);
